import React from 'react';
import { useSubscription } from '../context/SubscriptionContext';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * SubscriptionGate — gates only on auth/loading. Subscription enforcement
 * is delegated to API-level plan-limit checks and the in-app /billing page.
 * No route-level redirect to /manage-subscription occurs (Phase 19.22).
 */
export const SubscriptionGate = ({ children }) => {
  const { subscription, loading, isAdmin } = useSubscription();
  const { user, loading: authLoading } = useAuth();

  // Show loading while checking subscription
  if (loading || authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Not logged in - let auth handle redirect
  if (!user) {
    return children;
  }

  // Admins always have access
  if (isAdmin) {
    return children;
  }

  // Legacy users (existing before SaaS) - full access
  if (subscription?.plan === 'legacy') {
    return children;
  }

  // Phase 19.22 — per user directive, the redirect to /manage-subscription
  // is removed entirely. Authenticated users always land on their intended
  // route. Subscription/plan enforcement happens at the API layer
  // (plan-limit checks on each protected endpoint) and via the in-app
  // /billing page, not via a hard-bounce route guard. This eliminates the
  // bounce-to-outdated-plan-page issue after Stripe checkout for ANY
  // subscription_status (incomplete, past_due, etc.).
  return children;
};

export default SubscriptionGate;
